import React, { useMemo } from 'react';
import { formatMoney } from 'utils/storefront/format-resource';

const ProductBadges = ({ product, currentVariant, onSale }) => {
  const productSale = currentVariant?.metafields?.finalSale;
  const collectionSale = currentVariant.finalSale;

  const saleBadge = useMemo(() => {
    const price = currentVariant?.price || product.priceRange.minVariantPrice;
    const itemCompareAtPrice = currentVariant?.compareAtPrice || product.compareAtPriceRange.maxVariantPrice;
    const compareAtPrice = parseFloat(itemCompareAtPrice.amount) > 0 ? itemCompareAtPrice : null;
    if (!compareAtPrice || compareAtPrice === price.amount) return null;
    const discount = price.amount - itemCompareAtPrice.amount;
    const finalPrice = formatMoney({ amount: discount, currencyCode: price.currencyCode });
    return window.TMW.Strings.product.priceSaved.replace('{price}', finalPrice);
  }, [currentVariant]);

  if (!product?.metafields?.badgeText && !saleBadge) return null;

  const badgeText = product?.metafields?.badgeText || '';
  const isNewBadge = badgeText.toLowerCase().includes('new');

  const shouldShowBadge = badgeText && !(isNewBadge && onSale);
  const hideBadge = isNewBadge && collectionSale && !onSale;
  const proSale = isNewBadge && productSale && !onSale;

  return (
    <div className="absolute left-2.5 top-2.5 z-3 flex flex-wrap items-center gap-1">
      {saleBadge && <div className="caption rounded-md bg-white px-2 py-0.5 text-center">{saleBadge}</div>}
      {shouldShowBadge && !hideBadge && !proSale && (
        <div className="caption rounded-md bg-brand-light-beige px-2 py-0.5 text-center">{badgeText}</div>
      )}
    </div>
  );
};

export default ProductBadges;
